import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/core";
import { styles } from "./EmbeddedVideo.styles";

export interface EmbeddedVideoProps extends WithStyles<typeof styles> {
    embedId: string;
}

const EmbeddedVideoPure: React.FunctionComponent<EmbeddedVideoProps> = ({embedId, classes}: EmbeddedVideoProps) => (
    <div className={classes.videoResponsive}>
        <iframe
            width="580"
            height="300"
            src={`https://www.youtube-nocookie.com/embed/${embedId}?rel=0&origin=https://${window.location.hostname}`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Embedded youtube"
        />
    </div>
);


export const EmbeddedVideo = withStyles(styles)(EmbeddedVideoPure);